import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {Router} from "@angular/router";
import {tap} from "rxjs/operators";
import {InitResponse} from "../models/init-response";
import {Image} from "../models/image";
import {ImportStatus} from "../models/import-status";

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private _accessToken: BehaviorSubject<string> = new BehaviorSubject('');
  private _categories: BehaviorSubject<string[]> = new BehaviorSubject([]);
  private _images: BehaviorSubject<Image[]>=new BehaviorSubject<Image[]>([])
  // @ts-ignore
  private _user: BehaviorSubject<User> = new BehaviorSubject(null);
  private _apiServerUrl = '';
  private _initialized = false;
  private _category='';
  private _search='';
  public isLoading:boolean=true;
  public hasMore=false;
  public page=0;

  constructor(private http: HttpClient,  private router:Router) {

    if (window.location.href.indexOf('localhost') > 0) {
      this._apiServerUrl = 'http://localhost:8081';
    }
    console.log('API Service ready');
    this.getInit().subscribe(initResponse => {
      console.log("got init", initResponse);
      this._categories.next(initResponse.categories);
     // this._images.next(initResponse.images);
      this.page=initResponse.page;
      this.hasMore=initResponse.hasMore;
      this.isLoading=false;
    });
  }

  public isInitialized(): boolean{
    return this._initialized;
  }


  private getHttpOptions(params: any): any {
    let httpParams = new HttpParams();
    if(params) {
      Object.keys(params).forEach(key => {
        httpParams = httpParams.append(key,params[key]);
      });
    }
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params:httpParams
    };
  }

  public get(endpoint: string, params?: any): Observable<any> {
    if (params) {
      Object.keys(params).forEach(key => {
        if (params[key] instanceof Object) {
          params[key] = JSON.stringify(params[key]);
        }
      });
    }
    return this.http.get<any>(this._apiServerUrl + endpoint, this.getHttpOptions(params)).pipe(
      tap(posts => console.log(posts), error => {
        console.log('error', error);
      }),
    );
  }

  public post(endpoint: string, params?: any): Observable<any> {
    console.log('post params', params);
    const formData: FormData = new FormData();
    if (params) {
      Object.keys(params).forEach(key => {
        if (params[key] instanceof File) {
          formData.append(key, params[key]);
        } else if (params[key] instanceof Object) {
          formData.append(key, JSON.stringify(params[key]));
        } else {
          formData.append(key, params[key]);
        }
      });
    }
    return this.http.post(this._apiServerUrl + endpoint, formData).pipe(
      tap(resp => console.log(resp)),
    );
  }

  private getInit(): Observable<InitResponse>{
    return this.get('/wp-admin/admin-post.php?action=kuniweb_init');
  }

  private loadImages(page?:number){
    if(!page){
      page=0;
    }
    if(page==0){
      this._images.next([]);
    }
    this.isLoading=true;
    this.get('/wp-admin/admin-post.php', {'action':'kuniweb_images', page:page, search:this._search, category:this._category}).subscribe(
      response=>{
        if(page==0){
          this._images.next(response.images);
        }else{
          //its paging
          Array.prototype.push.apply(this._images.getValue(), response.images);
          console.log(this._images.getValue().length + " number of images");
        }
        this.isLoading=false;
        this.hasMore=response.hasMore;
        this.page=response.page;
      }
    );
  }

  public loadMore(){
    console.log("load more images");
    this.loadImages(this.page+1);
  }

  public getCategories(): Observable<string[]>{
    return this._categories;
  }

  public getImages():Observable<Image[]> {
    return this._images;
  }

  public getImportStep():Observable<ImportStatus> {
    return this.get('/wp-admin/admin-post.php?action=kuniweb_import_step');
  }

  setCategory(cat: string) {
    this._category=cat;
    this._images.next([]);
    this.loadImages();
  }

  setSearch(cat: string, reload: boolean) {
    this._search=cat;
    this._images.next([]);
    if(reload===true){
      this.loadImages();
    }
  }

}
